import { createBrowserRouter } from "react-router-dom";
import Main from "../layout/Main";
import Login from "../pages/Auth/Login";
import PrivateRoute from "../pages/Auth/RequireAuth";
import ReportPermissionRoute from "../pages/Auth/ReportPermissionRoute";
import Register from "../pages/Auth/Register";
import AccessStatus from "../pages/Auth/AccessStatus";
import PlatformAdminRoute from "../pages/Auth/PlatformAdminRoute";
import PlatformAdmin from "../pages/PlatformAdmin";
import Subscription from "../pages/Subscription";
import BusinessSettings from "../pages/BusinessSettings";
import StaffJoin from "../pages/Auth/StaffJoin";
import ChangePassword from "../pages/Auth/ChangePassword";
import ForcePasswordChangeRoute from "../pages/Auth/ForcePasswordChangeRoute";
import AddCustomer from "../pages/Dashboard/AddCustomer/AddCustomer";
import Dashboard from "../pages/Dashboard/Dashboard";
import DashboardHome from "../pages/Dashboard/DashboardHome";
import AddBrand from "../pages/ProductInfo/AddBrand/AddBrand";
import AddCategory from "../pages/ProductInfo/AddCategory/AddCategory";
import AddOrigin from "../pages/ProductInfo/AddOrigin/AddOrigin";
import AddProduct from "../pages/ProductInfo/AddProduct/AddSupplier";
import AddSupplier from "../pages/ProductInfo/AddSupplier/AddSupplier";
import AddUnit from "../pages/ProductInfo/AddUnit/AddUnit";
import AddPurchase from "../pages/Dashboard/Purchase/AddPurchase/AddPurchase";
import PurchaseList from "../pages/Dashboard/Purchase/ManagePurchase/PurchaseList";
import UpdateInvoice from "../pages/Dashboard/Purchase/ManagePurchase/UpdateInvoice/UpdateInvoice";
import AddSales from "../pages/SalesInvoice/AddSales";
import SalesList from "../pages/SalesInvoice/ManageInvoice/SalesList";
import CurrentStock from "../pages/Dashboard/Reports/CurrentStock/CurrentStock";
import InvoiceWiseProfit from "../pages/Dashboard/Reports/InvoiceWiseProfit/InvoiceWiseProfit";
import UpdateSalesInvoice from "../pages/SalesInvoice/ManageInvoice/UpdateInvoice/UpdateSalesInvoice";
import AddBikeSales from "../pages/Dashboard/Sales/AddSales/AddBikeSales";
import BikeSalesList from "../pages/Dashboard/Sales/ViewSales/BikeSalesList";
import UpdateBikeSalesInvoice from "../pages/Dashboard/Sales/ManageSales/UpdateBikeSalesInvoice";
import AddMainCustomer from "../pages/Dashboard/Customers/AddMainCustomer";
import AddExpenseHead from "../pages/Dashboard/AccountsInfo/AddExpenseHead/AddExpenseHead";
import AddIncomeHead from "../pages/Dashboard/AccountsInfo/AddIncomeHead/AddIncomeHead";
import AddBankAccount from "../pages/Dashboard/AccountsInfo/AddBankAccounts/AddBankAccount";
import AddLoanAccount from "../pages/Dashboard/AccountsInfo/AddLoanAccount/AddLoanAccount";
import AddIncome from "../pages/Dashboard/Transactions/AddIncome/AddIncome";
import AddExpense from "../pages/Dashboard/Transactions/AddExpense/AddExpense";
import AddCollection from "../pages/Dashboard/Transactions/AddCollection/AddCollection";
import AddPayment from "../pages/Dashboard/Transactions/AddPayment/AddPayment";
import AddBankDeposit from "../pages/Dashboard/Transactions/AddBankDeposit/AddBankDeposit";
import AddBankWithdraw from "../pages/Dashboard/Transactions/AddBankWithdraw/AddBankWithdraw";
import AddLoanTaken from "../pages/Dashboard/Transactions/AddLoanTaken/AddLoanTaken";
import AddLoanReturn from "../pages/Dashboard/Transactions/AddLoanReturn/AddLoanReturn";
import CashStatement from "../pages/Dashboard/Reports/CashStatement/CashStatement";
import BankStatement from "../pages/Dashboard/Reports/BankStatement/BankStatement";
import BalanceSheet from "../pages/Dashboard/Reports/BalanceSheet/BalanceSheet";
import AddOpeningCapital from "../pages/Dashboard/AccountsInfo/AddOpeningCapital/AddOpeningCapital";
import ProfitStatement from "../pages/Dashboard/Reports/ProfitStatement/ProfitStatement";
import CustomerDueReport from "../pages/Dashboard/Reports/CustomerDueReport/CustomerDueReport";
import SupplierDueReport from "../pages/Dashboard/Reports/SupplierDueReport/SupplierDueReport";
import AddUser from "../pages/Dashboard/UserManagement/AddUser/AddUser";
import LoanDueReport from "../pages/Dashboard/Reports/LoanDueReport/LoanDueReport";
import StockLedger from "../pages/Dashboard/Reports/StockLedger/StockLedger";
import CustomerLedgerReport from "../pages/Dashboard/Reports/CustomerLedgerReport/CustomerLedgerReport";
import SupplierLedgerReport from "../pages/Dashboard/Reports/SupplierLedgerReport/SupplierLedgerReport";
import ManageUser from "../pages/Dashboard/UserManagement/ManageUser/ManageUser";
import LoanLedgerReport from "../pages/Dashboard/Reports/LoanLedgerReport/LoanLedgerReport";
import TopSellingLessSelling from "../pages/Dashboard/Reports/TopSellingLessSelling/TopSellingLessSelling";
import StockOutReport from "../pages/Dashboard/Reports/StockOutReport/StockOutReport";
import AddPurchaseOrder from "../pages/Dashboard/Purchase/AddPurchaseOrder/AddPurchaseOrder";
import PurchaseOrderList from "../pages/Dashboard/Purchase/ManagePurchaseOrder/PurchaseOrderList";
import UpdatePurchaseOrder from "../pages/Dashboard/Purchase/ManagePurchaseOrder/UpdateInvoice/UpdatePurchaseOrder";
import BarCodeGen from "../pages/Dashboard/BarCodeGen/BarCodeGen";
import AddPosSales from "../pages/Dashboard/Sales/AddPosSales/AddPosSales";
import AddPosPurchase from "../pages/Dashboard/Purchase/AddPosPurchase/AddPosPurchase";
import PrintBarCode from "../pages/Dashboard/PrintBarCode/PrintBarCode";
import UpdatePosSales from "../pages/Dashboard/Sales/ManagePosSales/UpdatePosSales";
import UpdatePosPurchase from "../pages/Dashboard/Purchase/ManagePosPurchase/UpdatePosPurchase";
import ProfitStatementAdvance from "../pages/Dashboard/Reports/ProfitStatementAdvance/ProfitStatementAdvance";
import NewDashboard from "../pages/Dashboard/NewDashboard";
import AddSalesInvoice from "../pages/Dashboard/Sales/ManageSalesReturn/AddSalesInvoice";
import ReturnBikeSalesInvoice from "../pages/Dashboard/Sales/ManageSalesReturn/ReturnBikeSalesInvoice";
import ReturnSalesList from "../pages/Dashboard/Sales/ManageSalesReturn/ManageReturnSales/ReturnSalesList";
import MessageSetting from "../pages/Dashboard/Settings/MessageSetting";
import UpdateReturnBikeSalesInvoice from "../pages/Dashboard/Sales/ManageSalesReturn/ManageReturnSales/UpdateInvoice/UpdateReturnBikeSalesInvoice";
import PurchaseReturnInvoice from "../pages/Dashboard/Purchase/ManagePurchaseReturn/PurchaseReturnInvoice";
import ReturnPurchaseList from "../pages/Dashboard/Purchase/ManagePurchaseReturn/ManageReturnPurchase/ReturnPurchaseList";
import UpdatePurchaseReturnInvoice from "../pages/Dashboard/Purchase/ManagePurchaseReturn/ManageReturnPurchase/UpdateInvoice/UpdatePurchaseReturnInvoice";
import MobilePos from "../pages/MobilePos/MobilePos";
import MobileShell from "../pages/MobilePos/MobileShell";
import MobileHome from "../pages/MobilePos/MobileHome";
import MobileRouteNotFound from "../pages/MobilePos/MobileRouteNotFound";
import EcommerceWorkspace from "../pages/EcommerceWorkspace";
import { EcommerceDashboardShell } from "../pages/EcommerceDashboardShell";
import { EcommerceOverviewPage, EcommerceCataloguePage, EcommerceContentPage, EcommerceOrdersPage, EcommerceSettingsPage, EcommerceSetupPage, EcommerceCheckoutSettingsPage, EcommerceAddProductPage, EcommerceProductListPage, EcommerceAddCategoryPage, EcommerceAddBrandPage, EcommerceAddSliderPage, EcommerceSliderListPage, EcommerceAddBannerPage, EcommerceBannerListPage, EcommerceAddBlogPage, EcommerceBlogListPage, EcommerceBusinessInfoPage, EcommerceCheckoutInfoPage, EcommerceFaqInfoPage, EcommerceSeoInfoPage, EcommerceWebsiteSettingsPage, EcommerceApiInfoPage, EcommerceFraudCheckerPage } from "../pages/EcommerceDashboardModules";
import EcommercePageBuilderPage from "../pages/EcommercePageBuilderPage";
import { PublicProductPage, PublicStorefront } from "../pages/PublicStorefront";
import { PublicCategories, PublicCategoryPage, PublicProductsPage, PublicCartPage, PublicCheckoutPage, PublicThankYouPage, PublicBlogPage, PublicBrandsPage, PublicContactPage, PublicOrderTrackingPage } from "../pages/EcommerceStorefrontPages";




const routes = createBrowserRouter([
    { path: '/:storePath/products', element: <PublicProductsPage /> },
    { path: '/:storePath/allbooks', element: <PublicProductsPage /> },
    { path: '/:storePath/blog', element: <PublicBlogPage /> },
    { path: '/:storePath/brands', element: <PublicBrandsPage /> },
    { path: '/:storePath/contact', element: <PublicContactPage /> },
    { path: '/:storePath/orders', element: <PublicOrderTrackingPage /> },
    { path: '/:storePath/products/:productSlug', element: <PublicProductPage /> },
    { path: '/:storePath/categories', element: <PublicCategories /> },
    { path: '/:storePath/category/:category', element: <PublicCategoryPage /> },
    { path: '/:storePath/cart', element: <PublicCartPage /> },
    { path: '/:storePath/checkout', element: <PublicCheckoutPage /> },
    { path: '/:storePath/thank-you', element: <PublicThankYouPage /> },
    { path: '/:storePath', element: <PublicStorefront /> },
    { path: '/mobile/login', element: <Login /> },
    { path: '/mobile/register', element: <Register /> },
    { path: '/mobile/access-status', element: <AccessStatus /> },
    { path: '/mobile/change-password', element: <ForcePasswordChangeRoute><ChangePassword /></ForcePasswordChangeRoute> },
    {
        path: '/mobile',
        element: <PrivateRoute><MobileShell /></PrivateRoute>,
        children: [
            { index: true, element: <MobileHome /> },
            { path: 'pos', element: <MobilePos /> },
            { path: 'adduser', element: <AddUser /> },
            { path: 'addbrand', element: <AddBrand /> },
            { path: 'addcategory', element: <AddCategory /> },
            { path: 'addsupplier', element: <AddSupplier /> },
            { path: 'addunit', element: <AddUnit /> },
            { path: 'addorigin', element: <AddOrigin /> },
            { path: 'addproduct', element: <AddProduct /> },
            { path: 'addpurchase', element: <AddPurchase /> },
            { path: 'addpospurchase', element: <AddPosPurchase /> },
            { path: 'managepurchase', element: <PurchaseList /> },
            { path: 'addpurchaseorder', element: <AddPurchaseOrder /> },
            { path: 'managepurchaseorder', element: <PurchaseOrderList /> },
            { path: 'managepurchaseorder/edit/:editId', element: <UpdatePurchaseOrder /> },
            { path: 'managepurchase/edit/:editId', element: <UpdateInvoice /> },
            { path: 'managepospurchase/edit/:editId', element: <UpdatePosPurchase /> },
            { path: 'managereturnpurchase', element: <ReturnPurchaseList /> },
            { path: 'returnpurchase/edit/:editId', element: <PurchaseReturnInvoice /> },
            { path: 'returnpospurchase/edit/:editId', element: <PurchaseReturnInvoice /> },
            { path: 'updatereturnpurchase/edit/:editId', element: <UpdatePurchaseReturnInvoice /> },
            { path: 'addsales', element: <AddSales /> },
            { path: 'addsales/:customerId', element: <AddSales /> },
            { path: 'addpossales', element: <AddPosSales /> },
            { path: 'adddefaultsales', element: <AddBikeSales /> },
            { path: 'managedefaultsales', element: <BikeSalesList /> },
            { path: 'managedefaultsales/edit/:editId', element: <UpdateBikeSalesInvoice /> },
            { path: 'saleslist', element: <SalesList /> },
            { path: 'managesales/edit/:editId', element: <UpdateSalesInvoice /> },
            { path: 'updatepossales/edit/:editId', element: <UpdatePosSales /> },
            { path: 'managereturnsales', element: <ReturnSalesList /> },
            { path: 'returndefaultsales/edit/:editId', element: <ReturnBikeSalesInvoice /> },
            { path: 'returnpossales/edit/:editId', element: <ReturnBikeSalesInvoice /> },
            { path: 'updatereturndefaultsales/edit/:editId', element: <UpdateReturnBikeSalesInvoice /> },
            { path: 'addmaincustomer', element: <AddMainCustomer /> },
            { path: 'addcustomer', element: <AddCustomer /> },
            { path: 'addexpensehead', element: <AddExpenseHead /> },
            { path: 'addincomehead', element: <AddIncomeHead /> },
            { path: 'addbankaccount', element: <AddBankAccount /> },
            { path: 'addloanaccount', element: <AddLoanAccount /> },
            { path: 'addopeningcapital', element: <AddOpeningCapital /> },
            { path: 'addincome', element: <AddIncome /> },
            { path: 'addexpense', element: <AddExpense /> },
            { path: 'addcollection', element: <AddCollection /> },
            { path: 'addpayment', element: <AddPayment /> },
            { path: 'addbankdeposit', element: <AddBankDeposit /> },
            { path: 'addbankwithdraw', element: <AddBankWithdraw /> },
            { path: 'addloantaken', element: <AddLoanTaken /> },
            { path: 'addloanreturn', element: <AddLoanReturn /> },
            { path: 'printbarcode', element: <PrintBarCode /> },
            { path: 'smssetting', element: <MessageSetting /> },
            { path: 'reports/cashstatement', element: <ReportPermissionRoute permission="cashStatement"><CashStatement /></ReportPermissionRoute> },
            { path: 'reports/bankstatement', element: <ReportPermissionRoute permission="bankStatement"><BankStatement /></ReportPermissionRoute> },
            { path: 'reports/balancesheet', element: <ReportPermissionRoute permission="balanceSheet"><BalanceSheet /></ReportPermissionRoute> },
            { path: 'reports/profitsheet', element: <ReportPermissionRoute permission="profitSheet"><ProfitStatement /></ReportPermissionRoute> },
            { path: 'reports/profitsheetadvance', element: <ReportPermissionRoute permission="profitSheetAdvance"><ProfitStatementAdvance /></ReportPermissionRoute> },
            { path: 'reports/currentstock', element: <ReportPermissionRoute permission="currentStock"><CurrentStock /></ReportPermissionRoute> },
            { path: 'reports/customerduereport', element: <ReportPermissionRoute permission="customerDueReport"><CustomerDueReport /></ReportPermissionRoute> },
            { path: 'reports/supplierduereport', element: <ReportPermissionRoute permission="supplierDueReport"><SupplierDueReport /></ReportPermissionRoute> },
            { path: 'reports/loanduereport', element: <ReportPermissionRoute permission="loanDueReport"><LoanDueReport /></ReportPermissionRoute> },
            { path: 'reports/invoiceprofit', element: <ReportPermissionRoute permission="invoiceWiseProfit"><InvoiceWiseProfit /></ReportPermissionRoute> },
            { path: 'reports/stockledger', element: <ReportPermissionRoute permission="stockLedger"><StockLedger /></ReportPermissionRoute> },
            { path: 'reports/customerledger', element: <ReportPermissionRoute permission="customerLedgerReport"><CustomerLedgerReport /></ReportPermissionRoute> },
            { path: 'reports/supplierledger', element: <ReportPermissionRoute permission="supplierLedgerReport"><SupplierLedgerReport /></ReportPermissionRoute> },
            { path: 'reports/laonledger', element: <ReportPermissionRoute permission="loanLedgerReport"><LoanLedgerReport /></ReportPermissionRoute> },
            { path: 'reports/topsellinglessselling', element: <ReportPermissionRoute permission="topSellingLessSelling"><TopSellingLessSelling /></ReportPermissionRoute> },
            { path: 'reports/stockoutreport', element: <ReportPermissionRoute permission="stockOutReport"><StockOutReport /></ReportPermissionRoute> },
            { path: 'reports/barcode', element: <ReportPermissionRoute permission="barCode"><BarCodeGen /></ReportPermissionRoute> },
            { path: 'saas/business-settings', element: <BusinessSettings /> },
            { path: 'subscription', element: <Subscription /> },
            { path: 'platform-admin', element: <PlatformAdminRoute><PlatformAdmin /></PlatformAdminRoute> },
            { path: '*', element: <MobileRouteNotFound /> },
        ],
    },
    {
        path: '/',
        element: <Main />,
        children: [
            {
                path: '/',
                element: <PrivateRoute>
                    <Dashboard />
                </PrivateRoute>,
                children: [
                    {
                        path: '/',
                        element: <DashboardHome />
                    },
                    // {
                    //     path:'/newdashboard',
                    //     element:<NewDashboard/>
                    // },
                    {
                        path: '/adduser',
                        element: <AddUser />
                    },
                    {
                        path: "addbrand",
                        element: <AddBrand />,
                    },
                    {
                        path: "addcategory",
                        element: <AddCategory />,
                    },
                    {
                        path: "addsupplier",
                        element: <AddSupplier />,
                    },
                    {
                        path: "addunit",
                        element: <AddUnit />,
                    },
                    {
                        path: "addorigin",
                        element: <AddOrigin />,
                    },
                    {
                        path: "addproduct",
                        element: <AddProduct />,
                    },
                    {
                        path: "ecommerce",
                        element: <EcommerceDashboardShell />,
                        children: [
                            { index: true, element: <EcommerceOverviewPage /> },
                            { path: 'setup', element: <EcommerceSetupPage /> },
                            { path: 'studio', element: <EcommerceWorkspace /> },
                            { path: 'addproduct', element: <EcommerceAddProductPage /> },
                            { path: 'productlist', element: <EcommerceProductListPage /> },
                            { path: 'catalogue', element: <EcommerceCataloguePage /> },
                            { path: 'page-builder', element: <EcommercePageBuilderPage /> },
                            { path: 'pagebuilder', element: <EcommercePageBuilderPage /> },
                            { path: 'content', element: <EcommerceContentPage section="banners" /> },
                            { path: 'sliders', element: <EcommerceContentPage section="sliders" /> },
                            { path: 'product-media', element: <EcommerceContentPage section="productMedia" /> },
                            { path: 'addsliderimages', element: <EcommerceAddSliderPage /> },
                            { path: 'sliderimages', element: <EcommerceSliderListPage /> },
                            { path: 'addbanners', element: <EcommerceAddBannerPage /> },
                            { path: 'bannerimages', element: <EcommerceBannerListPage /> },
                            { path: 'detail-banners', element: <EcommerceContentPage section="detailBanners" /> },
                            { path: 'addcategory', element: <EcommerceAddCategoryPage /> },
                            { path: 'categories', element: <EcommerceContentPage section="categories" /> },
                            { path: 'addbrand', element: <EcommerceAddBrandPage /> },
                            { path: 'brands', element: <EcommerceContentPage section="brands" /> },
                            { path: 'offers', element: <EcommerceContentPage section="offers" /> },
                            { path: 'addblog', element: <EcommerceAddBlogPage /> },
                            { path: 'blog', element: <EcommerceContentPage section="blogs" /> },
                            { path: 'bloglist', element: <EcommerceBlogListPage /> },
                            { path: 'faq', element: <EcommerceContentPage section="faqs" /> },
                            { path: 'orders', element: <EcommerceOrdersPage /> },
                            { path: 'checkout', element: <EcommerceCheckoutSettingsPage /> },
                            { path: 'businessinfo', element: <EcommerceBusinessInfoPage /> },
                            { path: 'checkoutinfo', element: <EcommerceCheckoutInfoPage /> },
                            { path: 'faqinfo', element: <EcommerceFaqInfoPage /> },
                            { path: 'seoinfo', element: <EcommerceSeoInfoPage /> },
                            { path: 'websitesettings', element: <EcommerceWebsiteSettingsPage /> },
                            { path: 'apiinfo', element: <EcommerceApiInfoPage /> },
                            { path: 'fraudchecker', element: <EcommerceFraudCheckerPage /> },
                            { path: 'marketing', element: <EcommerceContentPage section="sliders" /> },
                            { path: 'analytics', element: <EcommerceOverviewPage /> },
                            { path: 'settings', element: <EcommerceSettingsPage /> },
                        ],
                    },
                    {
                        path: "addpurchase",
                        element: <AddPurchase />,
                    },
                    {
                        path: "addpospurchase",
                        element: <AddPosPurchase />,
                    },
                    {
                        path: "managepurchase",
                        element: <PurchaseList />,
                    },
                    {
                        path: "addpurchaseorder",
                        element: <AddPurchaseOrder />,
                    },
                    {
                        path: "managepurchaseorder",
                        element: <PurchaseOrderList />,
                    },
                    {
                        path: "managepurchaseorder/edit/:editId",
                        element: <UpdatePurchaseOrder />,
                    },
                    {
                        path: "managepurchase/edit/:editId",
                        element: <UpdateInvoice forceMobile />,
                    },
                    {
                        path: "managepospurchase/edit/:editId",
                        element: <UpdatePosPurchase forceMobile />,
                    },
                    {
                        path: "managesales/edit/:editId",
                        element: <UpdateSalesInvoice />,
                    },
                    {
                        path: "managedefaultsales/edit/:editId",
                        element: <UpdateBikeSalesInvoice />,
                    },
                    {
                        path: "managereturnsales",
                        element: <ReturnSalesList />,
                    },
                    {
                        path: "returndefaultsales/edit/:editId",
                        element: <ReturnBikeSalesInvoice />,
                    },
                    {
                        path: "returnpossales/edit/:editId",
                        element: <ReturnBikeSalesInvoice />,
                    },
                    {
                        path: "updatereturndefaultsales/edit/:editId",
                        element: <UpdateReturnBikeSalesInvoice />,
                    },
                    {
                        path: "managereturnpurchase",
                        element: <ReturnPurchaseList />,
                    },
                    {
                        path: "returnpurchase/edit/:editId",
                        element: <PurchaseReturnInvoice />,
                    },
                    {
                        path: "returnpospurchase/edit/:editId",
                        element: <PurchaseReturnInvoice />,
                    },
                    {
                        path: "updatereturnpurchase/edit/:editId",
                        element: <UpdatePurchaseReturnInvoice />,
                    },
                    // s
                    {
                        path: "addsales/:customerId",
                        element: <AddSales />,
                    },
                    {
                        path: "addsales",
                        element: <AddSales />,
                    },
                    {
                        path: "addpossales",
                        element: <AddPosSales />,
                    },
                    {
                        path: "updatepossales/edit/:editId",
                        element: <UpdatePosSales />,
                    },
                    {
                        path: "addmaincustomer",
                        element: <AddMainCustomer />,
                    },
                    {
                        path: "adddefaultsales",
                        element: <AddBikeSales />,
                    },
                    {
                        path: "managedefaultsales",
                        element: <BikeSalesList />,
                    },
                    {
                        path: "saleslist",
                        element: <SalesList />,
                    },
                    // Accounts Info
                    {
                        path: 'addexpensehead',
                        element: <AddExpenseHead />
                    },
                    {
                        path: 'addincomehead',
                        element: <AddIncomeHead />
                    },
                    {
                        path: 'addbankaccount',
                        element: <AddBankAccount />
                    },
                    {
                        path: 'addloanaccount',
                        element: <AddLoanAccount />
                    },
                    {
                        path: 'addopeningcapital',
                        element: <AddOpeningCapital />
                    },

                    // Transactions
                    {
                        path: 'addincome',
                        element: <AddIncome />
                    },
                    {
                        path: 'addexpense',
                        element: <AddExpense />
                    },
                    {
                        path: 'addcollection',
                        element: <AddCollection />
                    },
                    {
                        path: 'addpayment',
                        element: <AddPayment />
                    },
                    {
                        path: 'addbankdeposit',
                        element: <AddBankDeposit />
                    },
                    {
                        path: 'addbankwithdraw',
                        element: <AddBankWithdraw />
                    },
                    {
                        path: 'addloantaken',
                        element: <AddLoanTaken />
                    },
                    {
                        path: 'addloanreturn',
                        element: <AddLoanReturn />
                    },
                    {
                        path: 'printbarcode',
                        element: <PrintBarCode />
                    },
                    {
                        path: 'smssetting',
                        element: <MessageSetting />
                    },

                    // Reports
                    {
                        path: 'reports/cashstatement',
                        element: <ReportPermissionRoute permission="cashStatement"><CashStatement /></ReportPermissionRoute>
                    },
                    {
                        path: 'reports/bankstatement',
                        element: <ReportPermissionRoute permission="bankStatement"><BankStatement /></ReportPermissionRoute>
                    },
                    {
                        path: 'reports/balancesheet',
                        element: <ReportPermissionRoute permission="balanceSheet"><BalanceSheet /></ReportPermissionRoute>
                    },
                    {
                        path: 'reports/profitsheet',
                        element: <ReportPermissionRoute permission="profitSheet"><ProfitStatement /></ReportPermissionRoute>
                    },
                    {
                        path: 'reports/profitsheetadvance',
                        element: <ReportPermissionRoute permission="profitSheetAdvance"><ProfitStatementAdvance /></ReportPermissionRoute>
                    },
                    {
                        path: 'reports/currentstock',
                        element: <ReportPermissionRoute permission="currentStock"><CurrentStock /></ReportPermissionRoute>
                    },
                    {
                        path: 'reports/customerduereport',
                        element: <ReportPermissionRoute permission="customerDueReport"><CustomerDueReport /></ReportPermissionRoute>
                    },
                    {
                        path: 'reports/supplierduereport',
                        element: <ReportPermissionRoute permission="supplierDueReport"><SupplierDueReport /></ReportPermissionRoute>
                    },
                    {
                        path: 'reports/loanduereport',
                        element: <ReportPermissionRoute permission="loanDueReport"><LoanDueReport /></ReportPermissionRoute>
                    },
                    {
                        path: 'reports/invoiceprofit',
                        element: <ReportPermissionRoute permission="invoiceWiseProfit"><InvoiceWiseProfit /></ReportPermissionRoute>
                    },
                    {
                        path: 'reports/stockledger',
                        element: <ReportPermissionRoute permission="stockLedger"><StockLedger /></ReportPermissionRoute>
                    },
                    {
                        path: 'reports/customerledger',
                        element: <ReportPermissionRoute permission="customerLedgerReport"><CustomerLedgerReport /></ReportPermissionRoute>
                    },
                    {
                        path: 'reports/supplierledger',
                        element: <ReportPermissionRoute permission="supplierLedgerReport"><SupplierLedgerReport /></ReportPermissionRoute>
                    },
                    {
                        path: 'reports/laonledger',
                        element: <ReportPermissionRoute permission="loanLedgerReport"><LoanLedgerReport /></ReportPermissionRoute>
                    },
                    {
                        path: 'reports/topsellinglessselling',
                        element: <ReportPermissionRoute permission="topSellingLessSelling"><TopSellingLessSelling /></ReportPermissionRoute>
                    },
                    {
                        path: 'reports/stockoutreport',
                        element: <ReportPermissionRoute permission="stockOutReport"><StockOutReport /></ReportPermissionRoute>
                    },
                    {
                        path: 'reports/barcode',
                        element: <ReportPermissionRoute permission="barCode"><BarCodeGen /></ReportPermissionRoute>
                    },
                    {
                        path: 'saas/business-settings',
                        element: <BusinessSettings />
                    },
                ]
            },
            {
                path: '/login',
                element: <Login />
            },
            {
                path: '/register',
                element: <Register />
            },
            {
                path: '/access-status',
                element: <AccessStatus />
            },
            {
                path: '/platform-admin',
                element: <PlatformAdminRoute><PlatformAdmin /></PlatformAdminRoute>
            },
            {
                path: '/subscription',
                element: <PrivateRoute><Subscription /></PrivateRoute>
            },
            {
                path: '/staff-join',
                element: <StaffJoin />
            },
            {
                path: '/change-password',
                element: <ForcePasswordChangeRoute><ChangePassword /></ForcePasswordChangeRoute>
            },
            {
                path: '/addcustomer',
                element: <AddCustomer />
            }

        ]
    },
    // {
    //     path:'/:serviceId',
    // }
])


export default routes;
